
<template>
  <v-form ref="form" lazy-validation>
    <v-row>
      <v-col cols="12" md="7" v-if="includes_employee">
        <v-text-field v-model="contact.name" :rules="activeModalitySolution == 'retail' ? [] : required" :readonly="read_only"
          label="Nome" prepend-icon="mdi-account"></v-text-field>
      </v-col>
      <v-col cols="12" md="5" v-if="includes_employee">
        <v-text-field v-model="contact.position" :rules="activeModalitySolution == 'retail' ? [] : required" :readonly="read_only"
          label="Cargo" prepend-icon="mdi-clipboard-account-outline"></v-text-field>  
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="contact.celphone" :readonly="read_only" :rules="includes_employee ? [] : [...required]"
         label="Celular" v-mask="'(##) #####-####'" prepend-icon="mdi-cellphone"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="contact.telephone" :readonly="read_only" :rules="includes_employee ? [] : [...required]"
         label="Fixo" v-mask="'(##) ####-####'" prepend-icon="mdi-phone"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="contact.email" :readonly="read_only" :rules="[...emailRules]" 
         label="E-mail" prepend-icon="mdi-email"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="contact.comment" :readonly="read_only" 
         label="Comentários" prepend-icon="mdi-comment"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ContactForm',
  mixins: [ validations ],
  props:{
    contact:{
      required: true,
      type: Object,
    },
    includes_employee: {
      type: Boolean,
      default: false,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
  },
  computed: {
    ...mapState({
      activeModalitySolution: state => state.App.activeModalitySolution,
    }),
  },
}
</script>
